import React, { useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { useWizard } from 'ui-components/components/wizard/context';
import { messages } from '../../../../../messages';
import style from '../style.module.less';
import { PAYMENT_TAB } from '../../../../../utilities/constants';
import { useWalletRegistrationModalContext } from '../../../contexts/wallet-registration-modal-context';
import { useDeprecatedLocalStorage, WALLET_REGISTRATION_DATA } from '../../../../../../hooks/use-local-storage';
import { useWalletRegistrationFormContext } from '../../../contexts/wallet-registration-form-context';
import { useFsuiContext } from '../../../../../../financial-services-ui/fsui-context-provider';

export const BackButton = ({ disabled = false }) => {
  const { previousStep, stepBack, getStepLabel } = useWizard();
  const { preloadedSession } = useWalletRegistrationModalContext();
  const [walletRegistrationData] = useDeprecatedLocalStorage(WALLET_REGISTRATION_DATA);
  const { isPaymentComplete } = useWalletRegistrationFormContext();
  const { createPaymentSession } = useFsuiContext();

  const onClick = useCallback(async () => {
    // a session currently exists and it was successful via localStorage (IE redirect flow)
    const hasSuccessfulPreloadedSession = preloadedSession && walletRegistrationData[preloadedSession.sessionId]?.success;
    if (
      previousStep?.stepId === PAYMENT_TAB && // step we are going to
      (hasSuccessfulPreloadedSession || isPaymentComplete) // the credit card was successfully processed
    ) {
      // intentionally not awaiting, since this sets a loading state and the navigation will feel snappier
      createPaymentSession(true);
    }
    stepBack();
  }, [createPaymentSession, isPaymentComplete, preloadedSession, previousStep, stepBack, walletRegistrationData]);

  const isFirstStep = !previousStep;
  if (isFirstStep) {
    return null;
  }

  return (
    <Button className={classNames(style.button, style['back-link'])} disabled={disabled} onClick={onClick} theme='link'>
      <FormattedMessage
        {...messages.backButton}
        values={{
          previousStepLabel: getStepLabel(previousStep.stepId),
        }}
      />
    </Button>
  );
};

BackButton.propTypes = {
  disabled: PropTypes.bool,
};
